






import { POSAccessControlEvent, POSContact } from '@pos/interfaces/pos-v2';
import PosAccessControlService from '@pos/services/pos-access-control-service';
import BpcPosContactSummary from './pos-contact-summary.vue';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'bpc-last-contact-access',
  components: {
    BpcPosContactSummary,
  },
})
export default class PosLastContactAccess extends Vue {
  // PROPS
  @Prop({ type: Number, required: true }) readonly posSessionId: number;
  // DATA
  lastContactAccess: POSContact = null;
  loading = false;
  // COMPUTED
  get accessControlService(): PosAccessControlService {
    return this.$posService.accessControl;
  }
  // LIFE CYCLE
  mounted() {
    this.getLastContactAccess();
    this.listenForLastContactAccessChanges();
  }

  listenForLastContactAccessChanges() {
    this.accessControlService
      .getAccessControlEventChangesChannel()
      .listen('.BPC\\AccessControl\\Events\\AccessControlEventCreated', async data => {
        // Add the event and remove the last one
        const accessControlEvent: POSAccessControlEvent = data.posAccessControlEvent;
        if (accessControlEvent.event_type === 'in') {
          this.lastContactAccess = data.posContact;
        }
        console.log('AccessControlEventCreated', data);
      })
      .listen('.BPC\\AccessControl\\Events\\AccessControlEventEdited', async data => {
        console.log('AccessControlEventCreated', data);
      })
      .listen('.BPC\\AccessControl\\Events\\AccessControlEventDeleted', async data => {
        console.log('AccessControlEventCreated', data);
      });
  }
  // METHODS
  async getLastContactAccess() {
    this.loading = true;
    const lastContactAccess = await this.accessControlService.getLastContactAccess(
      this.posSessionId,
    );
    this.lastContactAccess = lastContactAccess;
    this.loading = false;
    console.log('getLastContactAccess', lastContactAccess);
  }

  showFullView() {
    console.log('showFullView');
  }
  // WATCH
}
